import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";

var Carousel = require('react-responsive-carousel').Carousel;
interface Props {
    images: any[]
}

export default function CarrouselWithThumbs(props: Props) {
    if (props.images === undefined || props.images.length === 0)
        return <></>

    const customRenderThumb = (children: any[]) =>
        children.map((item: any, index: number) => {
            return <img src={item.props.src} key={index} alt="" />;
        });

    return <Carousel showArrows={true} showStatus={false} autoPlay={false} infiniteLoop={true}
        renderThumbs={customRenderThumb}>
        {props.images.map((item: any, index: number) => (
            <img className="img-fluid" src={item.url500} key={index} alt="" />
        ))}
    </Carousel>
}